import { PayloadAction } from '@reduxjs/toolkit';
import createAppSlice from 'app/createAppSlice';
import type { SpendingState, TimeFrameKey } from './types';
import { computeRangeInfo } from './spendingUtils';
import { fetchLinkedItems, fetchSpendingTransactions } from './spendingAsync';

const initialState: SpendingState = {
  transactions: null,
  linkedItems: null,
  selectedRange: 'thisMonth',
  rangeInfo: computeRangeInfo('thisMonth'),
};

const spendingSlice = createAppSlice({
  name: 'spending',
  initialState,
  reducers: {
    setSelectedRange(state, action: PayloadAction<TimeFrameKey>) {
      state.selectedRange = action.payload;
      state.rangeInfo = computeRangeInfo(action.payload);
      // Clear stale data immediately so selectors do not present the previous
      // range's data as if it matched the new range.
      state.transactions = null;
    },
    resetSpending() {
      return {
        transactions: null,
        linkedItems: null,
        selectedRange: 'thisMonth',
        rangeInfo: computeRangeInfo('thisMonth'),
      };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchLinkedItems.fulfilled, (state, action) => {
        state.linkedItems = action.payload;
      })
      .addCase(fetchSpendingTransactions.fulfilled, (state, action) => {
        state.transactions = action.payload;
      })
      .addCase(fetchSpendingTransactions.rejected, (state, action) => {
        // Do NOT wipe transactions when the previous fan-out was aborted by
        // a rapid time-frame change — prevents flash of empty content.
        if (!action.meta.aborted) {
          state.transactions = [];
        }
      });
  },
});

export const { setSelectedRange, resetSpending } = spendingSlice.actions;
export default spendingSlice.reducer;
